import React from "react";
import FooterV2 from "components/FooterV2/FooterV2";
import styles from "./layout.module.scss";
import { useFetchUser } from "source/hooks";
import NavigationBar from "components/Global/Navigation/NavigationBar/NavigationBar";
import { isWebView } from "@tiicker/util/lib/is-web-view";

const NavbarLayout: React.FC = (props) => {
  const { user: u, loading } = useFetchUser();

  return (
    <>
      {!isWebView() && <NavigationBar />}
      {props.children}
      {!isWebView() && <FooterV2 />}
    </>
  );
};

export default NavbarLayout;
